/* global google */

export const createHTMLMapMarker = ({
    OverlayView = google.maps.OverlayView,
    ...args
  }) => {
    class HTMLMapMarker extends OverlayView {
      constructor() {
        super();
        this.id = args.id;
        this.uri = args.uri;
        this.wellId = args.hotelId;
        this.latlng = args.latlng;
        this.name = args.name;
        this.stars = args.stars;
        this.cloudUri = args.cloudUri;
        this.surveyAverage = args.surveyAverage;
        this.price = args.price;
        this.beforePromo = args.beforePromo;
        this.discount = args.discount;
        this.showPromotion = args.showPromotion;
        this.showHotSBlackFri = args.showHotSBlackFri;
        this.tax = args.tax;
        this.html = args.html;
        this.highlightedAttributes = args.highlightedAttributes;
        this.setMap(args.map);
      }
  
      createDiv() {
        this.div = document.createElement("div");
        this.div.style.position = "absolute";
        if (this.html) {
          this.div.innerHTML = this.html;
        }
        google.maps.event.addDomListener(this.div, "click", event => {
          google.maps.event.trigger(this, "click");
        });
      }
  
      update(newText) {
        if (this.div) {
            this.div.innerHTML = newText;
        } else {
          console.warn("createDiv() has not been called on this point", this);
        }
    }
      appendDivToOverlay() {
        const panes = this.getPanes();
        panes.overlayImage.appendChild(this.div);
      }
  
      positionDiv() {
        const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
        let offset = 25;
        if (point) {
          this.div.style.left = `${point.x - offset}px`;
          this.div.style.top = `${point.y - offset}px`;
        }
      }
  
      draw() {
        if (!this.div) {
          this.createDiv();
          this.appendDivToOverlay();
        }
        this.positionDiv();
      }
  
      remove() {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      }
  
      getPosition() {
        return this.latlng;
      }
  
      getDraggable() {
        return false;
      }

      getVisible() {
        return true;
      }
    }
  
    return new HTMLMapMarker();
  };
  

  